import { render, staticRenderFns } from "./CenterCategoriesPage.vue?vue&type=template&id=235ea142&scoped=true"
import script from "./CenterCategoriesPage.vue?vue&type=script&lang=js"
export * from "./CenterCategoriesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235ea142",
  null
  
)

export default component.exports